/* Herbz AutoCart UI v2: Section Store isolation, keyboard cards, mobile targets. */
(() => {
  'use strict';
  if (window.herbzAutoCartUIReady) return;
  window.herbzAutoCartUIReady = true;
  let activeDialog = null;
  let frame = 0;
  const backgrounds = new Map();
  const keyboardCards = new WeakSet();

  function isolateBackground(dialog) {
    document.querySelectorAll('section-store--cart-block, cart-drawer.active, cart-drawer[open], cart-drawer.is-open').forEach(drawer => {
      if (drawer.contains(dialog) || backgrounds.has(drawer)) return;
      backgrounds.set(drawer, { inert: drawer.inert, focus: document.activeElement });
      drawer.inert = true;
      if (drawer.matches('cart-drawer') && typeof window.removeTrapFocus === 'function') window.removeTrapFocus();
    });
  }

  function restoreBackgrounds() {
    const previous = Array.from(backgrounds.entries());
    backgrounds.clear();
    previous.forEach(([drawer, state]) => { drawer.inert = state.inert; });
    requestAnimationFrame(() => {
      if (activeDialog) return;
      previous.forEach(([drawer, state]) => {
        if (!drawer.isConnected || state.inert || !drawer.matches('cart-drawer.active, cart-drawer[open], cart-drawer.is-open')) return;
        const empty = drawer.querySelector('.drawer__inner-empty:not([hidden])');
        const target = drawer.classList.contains('is-empty') && empty ? empty : drawer.querySelector('#CartDrawer, .drawer__inner');
        if (!target) return;
        const focus = state.focus?.isConnected && target.contains(state.focus) ? state.focus : target;
        if (typeof window.trapFocus === 'function') window.trapFocus(target, focus);
        else focus.focus({ preventScroll: true });
      });
    });
  }

  function setAttribute(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function sync() {
    frame = 0;
    const dialog = document.querySelector('#ac-dialog');
    const confirmation = document.querySelector('[data-autocart-confirmation]')?.shadowRoot?.querySelector('dialog[open]');
    const open = (dialog && dialog.getAttribute('data-state') !== 'closed') || confirmation;
    if (!open) {
      if (!activeDialog) return;
      activeDialog = null;
      document.documentElement.classList.remove('herbz-autocart-open');
      restoreBackgrounds();
      return;
    }
    activeDialog = dialog || confirmation;
    isolateBackground(activeDialog);
    document.documentElement.classList.add('herbz-autocart-open');
    if (!dialog) return;
    dialog.querySelectorAll('[aria-roledescription="carousel"]').forEach(carousel => {
      carousel.toggleAttribute('data-herbz-two-options', carousel.querySelectorAll('[aria-roledescription="slide"]').length === 2);
    });
    const decline = dialog.querySelector('label[for="terms"]')?.parentElement;
    if (decline) setAttribute(decline, 'data-herbz-decline', '');
    dialog.querySelectorAll('form button.ac-flex-shrink-0').forEach(button => {
      if (!button.hasAttribute('aria-label')) setAttribute(button, 'aria-label', 'Fjern valg');
    });
    dialog.querySelectorAll('img:not([alt])').forEach(img => setAttribute(img, 'alt', ''));
    dialog.querySelectorAll('.ac-bg-card.ac-transition-outline').forEach(card => {
      const slide = card.closest('[aria-roledescription="slide"]');
      const title = card.querySelector('h3');
      // Multi-variant products retain the app's own variant selector.
      if (!title || slide?.querySelector('[role="combobox"]')) return;
      const disabled = card.classList.contains('ac-opacity-50');
      setAttribute(card, 'role', 'button');
      setAttribute(card, 'tabindex', disabled ? '-1' : '0');
      setAttribute(card, 'aria-label', `Vælg ${title.textContent.trim()}`);
      setAttribute(card, 'aria-pressed', String(card.classList.contains('ac-outline-primary')));
      setAttribute(card, 'aria-disabled', String(disabled));
      if (!keyboardCards.has(card)) {
        keyboardCards.add(card);
        card.addEventListener('keydown', event => {
          if (event.target !== card || !['Enter', ' '].includes(event.key)) return;
          event.preventDefault();
          if (card.getAttribute('aria-disabled') !== 'true') card.click();
        });
      }
    });
    const counter = dialog.querySelector('[data-slot="dialog-footer"] h4');
    if (counter) {
      setAttribute(counter, 'aria-live', 'polite');
      setAttribute(counter, 'aria-atomic', 'true');
    }
  }

  function schedule() { if (!frame) frame = requestAnimationFrame(sync); }
  new MutationObserver(mutations => {
    if (mutations.some(m => m.type === 'childList' || m.attributeName === 'data-state' ||
        m.target.closest?.('#ac-dialog') || m.target.matches?.('cart-drawer, section-store--cart-block'))) schedule();
  }).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['data-state', 'class', 'disabled']
  });
  sync();
})();
